import { HandleClickProps } from '../../types/optimizerTable';
export const handleCheckboxChange = async ({
  id,
  selected,
  setSelected,
  records,
  rowId,
  setRecordsData,
}: HandleClickProps) => {
  const newSelected = selected.includes(id)
    ? selected.filter((selectedId) => selectedId !== id)
    : [...selected, id];
  setSelected(newSelected);
  const updatedRecords = records.map((record) => {
    if (record.id === rowId) {
      return {
        ...record,
        optimizationOptions: record.optimizationOptions.map((option) => {
          if (option.id === id) {
            return {
              ...option,
              enabled: !option.enabled,
            };
          }
          return option;
        }),
      };
    }
    return record;
  });
  setRecordsData(updatedRecords);
};
